import imagesLoaded from 'imagesloaded';
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

import gsap from '../lib/gsap.min';
import ScrollTrigger from '../lib/ScrollTrigger.min';
import ScrollToPlugin from '../lib/ScrollToPlugin.min';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import Swiper from 'swiper/bundle';
import Chart from 'chart.js/auto';


export function main() {
	
var Module = {};
var body;

Module.Compornent = {
	mobileToggleAsset: false,
	checkClass: function($this){
		$this = null;
	}
};

(function($) {
Module.Events = (function (){
'use strict';

var OBSERVER = {
	handlers: [],
	observeEvents: function(target){
		this.handlers.push(target);
	},
	deleteListener: function(element,listener){
		element.off(listener);
		element = null;
		listener = null;
	},
	clearEvents: function(){
		$(window).off('scroll resize');
	}
};

const body = $('body');
let winH = $(window).height();
let winW = $(window).width();

let tar_offset;
if( $('#heade_nav').length ){
  tar_offset = $('#heade_nav').outerHeight(true);
}else{
  tar_offset = 0;
}


let tl_nav;
const navanimation = () => {
  gsap.set('#main_nav', {autoAlpha:0});
	tl_nav = gsap.timeline({paused:true})
	.fromTo('#main_nav',
		{autoAlpha:0},
		{autoAlpha:1, duration:0.8, ease:'power4.out'})
	.fromTo('#main_nav li',
		{y:40, opacity:0},
		{y:0, opacity:1, duration:0.8, ease:'power4.out', stagger:0.05},'<');
}

const nav_show = () => {
  tl_nav.timeScale(1).play();
  body.addClass('navopen');
  body.removeClass('navclose');
};

const nav_hide = () => {
  tl_nav.timeScale(2).reverse();
  body.addClass('navclose');
  body.removeClass('navopen');
};

function navInit(){
  navanimation();
	body.addClass('navclose');
	$('#nav_btn').on('click', function(){
		if( body.hasClass('navopen') ){
			nav_hide();
		}else{
			nav_show();
		}
	});
	// window.addEventListener('scroll', function(){
	// 	nav_hide();
	// });
}

function navChange(){
	nav_hide();
	const namespace = $('[data-barba="container"]').attr('data-barba-namespace');
	$('#nav').attr('data-namespace', namespace);
	$('#nav').find('a').each(function(){
		$(this).removeClass('current');
		const _a_name = $(this).attr('data-namespace');
		if( _a_name == namespace ){
			$(this).addClass('current');
		}
	});
}


function elFunc(){
	let mm = gsap.matchMedia();
	document.querySelectorAll('.el').forEach((_tar, i) => {
		let _elmc = _tar.querySelectorAll('.elc');
		if( _elmc.length == 0 ){
			_elmc = _tar;
		}
		gsap.set(_elmc,{ opacity:0, y:60 });
		gsap.to(_elmc,
			{ opacity:1, y:0, 
				duration: 1.2,
				ease: "power4.out",
 				stagger: 0.1,
				scrollTrigger: {
					trigger: _tar,
					start: "top bottom-=10%",
					onRefresh: self => self.progress === 1 && self.animation.progress(1),
				},
				onStart: function(){
					_tar.classList.add('elon');
				}
			}
		);
	});

	const up_scrollTrigger = ScrollTrigger.create({
		trigger: body,
		start: "top top",
		onUpdate: self => {
			const _slfscrl = self.scroll();
			if(self.direction == -1){
				document.body.classList.remove('scrldown');
			}else{
				if(_slfscrl > 10){
					if(self.prevSclrl < _slfscrl-1){
						document.body.classList.add('scrldown');
					}
					self.prevSclrl = _slfscrl;
				}
			}
			scrltop (_slfscrl);
		},
	});
	body.addClass('scrltop');
}
const scrltop = (_slfscrl) => {
	if(_slfscrl > 10){
		body.removeClass('scrltop');
		body.addClass('scrl');
	}else{
		body.removeClass('scrl');
		body.addClass('scrltop');
	}
}


async function ScrollSmootherKill() {
	await new Promise((resolve, reject) => {
		ScrollTrigger.killAll();
		resolve();
	})
}


function anchorLink(){
	$('a.anchor').on('click', function(e){
		e.preventDefault();
		// e.stopPropagation();
		nav_hide();
		let hrefPageUrl = $(this).prop("href");
		hrefPageUrl = hrefPageUrl.split("#")[0];
		let currentUrl = location.href;
		currentUrl = currentUrl.split("#")[0];
		if( hrefPageUrl == currentUrl ){
			let href = this.hash;
			gsap.to(window, { duration:0.6, scrollTo:{y:href, autoKill:false, offsetY:tar_offset}, ease:'power2'});	
		}
	});
}


const contact_Cf7 = () => {
	if (wpcf7 && typeof wpcf7.init === 'function') { 
		document.querySelectorAll( '.wpcf7 > form' ).forEach( function( form ) {
			wpcf7.init( form );
		});
	}
}

function expandFunc() {
	const expand = (parent, state) => {
		if(state){
			parent.classList.add('open');
		}else{
			parent.classList.remove('open');
		}
		const exc = parent.querySelector('.exc');
		gsap.utils.toArray(exc).forEach(ex => {
			gsap.to(ex,{
				height: (!state) ? 0 : "auto",
				duration:0.3,
				ease: "power2.inOut",
				onComplete: () => {
					ScrollTrigger.refresh();
				}
			});
		});
	}
	const expand_event = (e) => {
		let parent = e.target.closest('.ex');
		const result = parent.classList.contains('open');
		if (result) {
			expand(parent, false);
		}else{
			expand(parent, true);
		}
	};
	gsap.utils.toArray('.exbtn').forEach(exbtn => {
		let parent = exbtn.closest('.ex');
		expand(parent, false);
		exbtn.removeEventListener('click',expand_event);
		exbtn.addEventListener('click',expand_event);
	});
}


function videoeSwitch() {
	const videoelm = document.getElementById('topvideo');
	const videosp = '_sp.';
	const videopc = '_pc.';
	let videoState = 1;
	const mm = gsap.matchMedia();
	mm.add("(min-width: 768px)", () => {
		if(videoState == 0){
			var srcname = videoelm.getAttribute('src').replace(videosp, videopc);
			videoelm.src = srcname;
			videoState = 1;	
		}
	});
	mm.add("(max-width: 767px)", () => {
		if(videoState == 1){
			var srcname = videoelm.getAttribute('src').replace(videopc, videosp);
			videoelm.src = srcname;
			videoState = 0;	
		}
	});
	videoelm.style.opacity = 1;
}


function elParallax(){
  gsap.utils.toArray('.para').forEach((_para,i) => {
    const _img = _para.querySelector('img');
    gsap.fromTo(_img, {y: 0},
      {
        y: ()=> _para.offsetHeight - _img.offsetHeight,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: _para,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 2,
        },
      }
    );
  });

  gsap.utils.toArray('.parael').forEach((_para,i) => {
    const _val = (_para.dataset.para) ? _para.dataset.para : 0;
    gsap.from(_para,
      {
        y: ()=> _val,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: _para,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 2,
        },
      }
    );
  });
}


function topService() {
  const _service_list = document.querySelectorAll('#service_list a');
  const _service_list_img = document.querySelectorAll('#service_img .img');
  gsap.set(_service_list_img[0], {opacity:1});
  _service_list.forEach((el, i) => {
    el.addEventListener('mouseenter', function(e){
      _service_list_img[i].classList.add('active');
      for(let j = 0; j < _service_list_img.length; j++){
        if(i != j){
          _service_list_img[j].classList.remove('active');
        }
      }
    });
  });
}


function chartFunc(){
  const htmlLegend = (colors, data, target) =>{
    let labels = data.labels.map((label, index) => {
      return `<li><span class="colortip" style="background-color:${colors[index]}"></span>${label}</li>`;
    }).join('');
    $(target).html(labels);
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function() {
            return '';
          },
          label: function(context) {
            let label = context.label || '';
            if (label) {
              label += ': ';
            }
            const value = context.raw;  
            return `${label}${value}%`;
          }
        }
      },
    },
  };
  const colors = [
    '#AECDE1',
    '#3B76AF',
    '#BBDE93',
    '#549E3F',
    '#ED9E9C',
  ];

  const langData = {
    datasets: [{
      data: [32, 20, 19, 15, 14],
      backgroundColor: colors,
    }],
    labels: [
      'PHP',
      'C#',
      'Python',
      'VB.NET',
      'その他',
    ]
  };
  htmlLegend(colors, langData, '#legend_chartLang');

  const dbData = {
    datasets: [{
      data: [35, 25, 17, 15, 8],
      backgroundColor: colors,
    }],
    labels: [
      'PostgreSQL',
      'SQLServer',
      'MySQL, MariaDB',
      'Oracle',
      'その他',
    ]
  };
  htmlLegend(colors, dbData, '#legend_chartDb');

  const scrollTrigger = ScrollTrigger.create({
		trigger: '#chart_sec',
		start: "top center",
    once: true,
		onEnter: self => {
      new Chart(
        $('#chartLang'), {
          type: 'pie',
          data: langData,
          options: options,
        }
      );
      new Chart(
        $('#chartDb'), {
          type: 'pie',
          data: dbData,
          options: options,
        }
      );
    }
  });
}


function galleryFunc(){
  gsap.from('.ga_img img', {
    scale: 0,
    duration: 0.6,
    ease:'power2.out',
    stagger: {
      amount: 0.1,
      from: 'random',
    },
    scrollTrigger: {
      trigger: '#gallery',
      start: "top bottom",
    },
  })
}


function sidenavFunc(){
  document.querySelectorAll('.emp_blc').forEach((emp_blk) => {
    const id = emp_blk.getAttribute('id');
    const emp_link = document.querySelector(`.emp_link[href="#${id}"]`);
    ScrollTrigger.create({
      trigger: emp_blk,
      start: 'top center',
      end: 'bottom center',
      onEnter: () => emp_link.classList.add('current'),
      onLeave: () => emp_link.classList.remove('current'),
      onEnterBack: () => emp_link.classList.add('current'),
      onLeaveBack: () => emp_link.classList.remove('current'),
    });
  });
}


function barFunc(){
  gsap.from('#credential .bar', {
    scaleX: 0,
    transformOrigin: '0 50%',
    duration: 0.6,
    ease:'power2.out',
    stagger: {
      amount: 0.1,
    },
    scrollTrigger: {
      trigger: '#credential',
      start: "bottom bottom",
    },
  })
}



var PageEvents = {
	loadFunc: function(){
		navInit();
	},
	commonFunc: function(){
		this.pjaxReadyFunc();
		winH = $(window).height();
		winW = $(window).width();	
		anchorLink();
		navChange();
		elFunc();
		expandFunc();
    elParallax();
		OBSERVER.observeEvents(1);
	},
	pjaxReadyFunc: function(){
	},
	topFunc: async function(){
		body.addClass('top');
    videoeSwitch();
    topService();
	},
  works_archiveFunc: function(){
    chartFunc();
  },
  careersFunc: function(){
    galleryFunc();
    sidenavFunc();
    barFunc();
  },
};

const replaceBogo = function(data){
	let target = '#wrapper';
	if(data){
		target = data.next.html;
	}
	const $newPageBogo = $(target).find('.bogo-language-switcher').html();
	const bogo = document.getElementById('bogo');
	bogo.innerHTML = $newPageBogo;
	bogo.querySelectorAll('a').forEach(a => {
		a.classList.add('nopj');
	});
}

function pjaxSettings(){

	barba.use(barbaPrefetch);

	// replaceBogo();

	const replaceHead = function(data){
		const head = document.head;
		const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
		const newPageHead = document.createElement('head');
		newPageHead.innerHTML = newPageRawHead;
		const removeHeadTags = [ 
			"meta[name='keywords']"
			,"meta[name='description']"
			,"meta[property^='og']"
			,"meta[name^='twitter']"
			,"meta[itemprop]"
			,"link[itemprop]"
			,"link[rel='prev']"
			,"link[rel='next']"
			,"link[rel='canonical']"
		].join(',');
		const headTags = head.querySelectorAll(removeHeadTags)
		for(let i = 0; i < headTags.length; i++ ){
			head.removeChild(headTags[i]);
		}
		const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)
		for(let i = 0; i < newHeadTags.length; i++ ){
			head.appendChild(newHeadTags[i]);
		}
	}

	var eventDelete = function eventDelete(e) {
		if (e.currentTarget.href === window.location.href) {
			e.preventDefault()
			e.stopPropagation()
			return
		}
	}
	const links = Array.prototype.slice.call(document.querySelectorAll('a[href]'));
		links.forEach(function (link) {
			link.addEventListener('click', function (e) {
			eventDelete(e)
		}, false)
	})

	var gaPush = function gaPush(pagename) {
		if (typeof ga === 'function' && Barba.HistoryManager.history.length >= 1) {
			ga('send', 'pageview', pagename);
		}
		if (typeof gtag === 'function' && Barba.HistoryManager.history.length >= 1) { 
			// gtag('config', 'G-Xxxxxxxx', {'page_path': pagename}); 
		}
	}

	var preventSettings = function preventSettings(el) {
		let href = el.getAttribute('href');
		if (href == null) {
				href = el.getAttribute('xlink:href');
		}
		if (el.classList.contains('pj')) {
			return false;
		}
		if (el.classList.contains('nopj')) {
				return true;
		}
		let site_url = location.protocol + '//' + location.host;
		if (!href.startsWith(site_url)) {
				el.setAttribute('target', '_blank');
				return true;
		}
		let url = location.protocol + '//' + location.host + location.pathname;
		let extract_hash = href.replace(/#.*$/, "");
		if (href.startsWith(location.protocol + '//' + location.host)) {
				if (href.indexOf('#') > -1 && extract_hash == url) {
						return false;
				}
		}
		if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(href.toLowerCase())) {
				el.setAttribute('target', '_blank');
				return true;
		}
		return false;
	}

	async function scroll(data) {
		await new Promise((resolve, reject) => {
			let scrltarget = 0;
			if(data.trigger === "back") {
				scrltarget = scrollPosY;
			}
			scrollPosY = barba.history.current.scroll.y;
			if(data.trigger === "forward"){
				scrltarget = scrollForwardPosY;
			}

			if(location.hash){
				var anchor = document.querySelector( location.hash );
				if(anchor){
					var target = location.hash;
					gsap.to(window, { duration:0, scrollTo:{y:target, autoKill:false, offsetY:tar_offset}, ease:'power2', onComplete:function(){
						body.addClass('scrldown');
						resolve();
					}});	
				}else{
					gsap.to(window, { duration:0, scrollTo:0, ease:'power2', onComplete:function(){
						resolve();
					}});
				}
			}else{
				gsap.to(window, { duration:0, scrollTo:scrltarget, ease:'power2', onComplete:function(){
					body.removeClass('scrldown');
					resolve();
				}});
			}
		})
	}


	barba.init({
		prevent: function prevent(_ref) {
			var el = _ref.el;
			return preventSettings(el);
		},
		timeout: 10000,			
		transitions: [{
			name: 'transition',
			sync:true,
			leave:function(data) {
				const done = this.async();
				gsap.to('#footer', {opacity:0, duration:0.2})
				gsap.to(data.current.container, {opacity:0, duration:0.2, onComplete:function(){
					ScrollSmootherKill();
					done();
				}});
			},
			enter:function(data) {
				const done = this.async();
				const $elm = $(data.next.container);
				$elm.css({'opacity':0});
				done();
			}
		}]
	})

	barba.hooks.beforeLeave(() => {
		body.removeClass('ready top inpage navopen scrldown scrltop scrl');
	});

	barba.hooks.beforeEnter((data) => {
		replaceHead(data);
		// replaceBogo(data);
		if( OBSERVER.handlers.length ){
			OBSERVER.clearEvents();
		}
		gaPush(location.pathname);
	});

	if (history.scrollRestoration) {
		history.scrollRestoration = 'manual';
	}
	var scrollPosY = 0;
	var scrollForwardPosY = 0;
	barba.hooks.leave((data) => {
		scrollForwardPosY = data.current.container.scroll.y;
	});

	barba.hooks.after((data) => {
		scroll(data);
		async function callerFun(){
			pageCheck();
			if( document.getElementById('form_blc') ){
				contact_Cf7();
			}	
			gsap.to('footer', {opacity:1, duration:0.6})
			gsap.to(data.next.container, {opacity:1, duration:0.6, onStart:function(){
			}});
		}
		$('#container').imagesLoaded( function() {
			callerFun();
		});
	});
}

async function pageCheck() {
	await new Promise((resolve, reject) => {
		PageEvents.commonFunc();

		if( document.getElementById('top') ){
			PageEvents.topFunc();
		}else{
			body.addClass('inpage');
		}
    if( document.getElementById('works_archive') ){
      PageEvents.works_archiveFunc();
    }
    if( document.getElementById('careers') ){
      PageEvents.careersFunc();
    }
		body.addClass('ready');
		resolve();
	})
}

function initialize(){
	window.addEventListener('DOMContentLoaded', function(){
		PageEvents.loadFunc();
		pageCheck();
		pjaxSettings();
	});
	window.addEventListener('load', function(){
		body.addClass('siteloaded');
	});
}

initialize();

})();
})( jQuery );

}